// option-content.component.ts
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

interface ContentItem {
  name: string;
  del?: boolean;
}

interface Option {
  value: string;
  formatted?: string;
  contains?: ContentItem[];
}

@Component({
  selector: 'app-option-content',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex-grow w-full">
      <div class="flex justify-between items-center text-theme-primary">
        <span [class]="'font-medium' + (isLarge ? ' text-lg' : '')">
        {{ getString(regex ? option.value.replace(regex, " ") : option.value) }}
        </span>
        <span *ngIf="!itemIncluded && option.formatted" class="tabular-nums text-end">{{option.formatted}}</span>
      </div>
      <div *ngIf="option.contains" class="text-sm opacity-75">
        {{getString("INNEHÅLLER", "upper")}}
        <span *ngFor="let con of option.contains; let last = last">
          {{getString(con.name, "upper")}}{{con.del ? "*" : ""}}{{last ? "" : ", "}}
        </span>
      </div>
    </div>
  `
})
export class OptionContentComponent {
  @Input() option!: Option;
  @Input() itemIncluded = false;
  @Input() isLarge = false;
  @Input() regex?: RegExp;

  getString(value: string, transform?: string): string {
    // Implement your getString logic here or inject a service
    return transform === 'upper' ? value.toUpperCase() : value;
  }
}
